import { useProactiveSessionRefresh } from '../hooks/useProactiveSessionRefresh';

/**
 * Mount trong tree app (sau Redux) để bật refresh chủ động; không render UI.
 */
export function SessionRefreshScheduler(): null {
  useProactiveSessionRefresh();
  return null;
}
